import axios from 'axios'

import { URL_PREFIX } from '../config'

export const getArtist = (user_id, cancelToken = null) => {
  return axios.get(URL_PREFIX + '/artists/' + user_id + '/', {
      cancelToken: cancelToken?.token
  })
}

export const getArtistProfile = (artist_id) => {
  return axios.get(URL_PREFIX + '/artist-profiles/' + artist_id + '/')
}

export const getArtistProfilePublic = (artist_id) => {
  return axios.get(URL_PREFIX + '/artist-profiles-public/' + artist_id + '/')
}

export const getArtistPermissions = (page = 1, pageSize = 2147483647, CancelToken=null) => {
  return axios.get(URL_PREFIX + '/artist-permissions/?page=' + page + '&page_size=' + pageSize, {
      cancelToken: CancelToken?.token
  })
}

export const getArtistPermission = (artist_id) => {
  return axios.get(URL_PREFIX + '/artist-permissions/' + artist_id + '/')
}

export const patchArtistPermission = (artist_id, param) => {
  return axios.patch(URL_PREFIX + '/artist-permissions/' + artist_id + '/', param)
}


export const getArtistsAdmin = (page = 1, pageSize = 2147483647, ordering='-id') => {
  let params = {ordering: ordering, page:page, pageSize:pageSize}
  return axios.get(URL_PREFIX + '/artists-admin/?page=' + page + '&page_size=' + pageSize, {
    params: params
  })
}


export const getArtistAdmin = (artist_id) => {
  return axios.get(URL_PREFIX + '/artists-admin/' + artist_id + '/')
}

export const putArtist = (user_id, param) => {
  return axios.put(URL_PREFIX + '/artists/' + user_id + '/', param)
}

export const patchArtist = (user_id, param) => {
  return axios.patch(URL_PREFIX + '/artists/' + user_id + '/', {
    user_id,
    ...param
  })
}

export const patchArtistProfile = (artist_id, param) => {
  return axios.patch(URL_PREFIX + '/artist-profiles/' + artist_id + '/', {
    artist_id,
    ...param
  })
}

export const adminChangeApplyStatus = (user_id, is_approve) => {
    return axios.post('/user-apply-artist-decision/', {
    user_id: user_id,
    is_approve: is_approve
  })
}
